(function(){
    var sec = document.currentScript.previousElementSibling;
    while (sec && !sec.classList.contains('tp-suh')) { sec = sec.previousElementSibling; }
    if (!sec) return;
    var btns = sec.querySelectorAll('[data-open-talki]');
    var hint = sec.querySelector('[data-talki-hint]');
    var sel = sec.getAttribute('data-widget-selector') || '';

    function openWidget(e){
      if (e && e.preventDefault) e.preventDefault();
      var ok = false;
      // 1) explizit konfigurierter Selektor
      if (sel) {
        try { var el = document.querySelector(sel); if (el) { el.click(); ok = true; } } catch(e){}
      }
      // 2) bekannte Launcher-Selektoren als Fallback
      if (!ok) {
        var guesses = ['#talki-launcher','.talki-launcher','[data-talki-launcher]','#chat-widget-launcher','.chat-launcher','iframe[title*="hat" i]'];
        for (var i=0;i<guesses.length;i++){
          var g = document.querySelector(guesses[i]);
          if (g) { try { g.click(); ok = true; break; } catch(e){} }
        }
      }
      // 3) globale API als Fallback
      if (!ok && typeof window.openTalki === 'function') { try { window.openTalki(); ok = true; } catch(e){} }
      // 4) nichts gefunden -> visuellen Hinweis nach unten-links zeigen
      if (!ok && hint) {
        hint.classList.add('is-on');
        setTimeout(function(){ hint.classList.remove('is-on'); }, 6000);
      }
    }
    for (var b = 0; b < btns.length; b++) { btns[b].addEventListener('click', openWidget); }
  })();
